import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import palette from "../styles/palette";

export const MainLink = styled(NavLink)`
  align-items: baseline;
  color: ${(prop) => (prop.color ? prop.color : null)};
  display: inline-flex;
  font-weight: bold;
  opacity: 0.8;
  text-decoration: none;
  text-transform: uppercase;
  transition: opacity 0.3s ease;

  &:hover,
  &:focus {
    opacity: 1;
    text-decoration: underline;
  }
`;

export const Link = styled(NavLink)`
  align-items: baseline;
  color: ${(prop) => (prop.color ? prop.color : palette.secondary.main)};
  display: inline-flex;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

type AProps = {
  to: string;
  children: React.ReactNode;
  big?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  colorContrast?: keyof typeof palette | "box" | false;
  target?: string | null;
  tabIndex?: number | null;
  className?: string;
  color?: string | null;
};

const A: React.FC<AProps> = React.memo(
  ({
    to,
    children,
    big = false,
    onClick = null,
    colorContrast = false,
    target = null,
    tabIndex = null,
    className,
    color = null,
  }) => {
    let computedColor = color;
    if (
      !computedColor &&
      colorContrast &&
      typeof colorContrast === "string" &&
      palette[colorContrast]
    ) {
      const paletteEntry = palette[colorContrast] as unknown as Record<
        string,
        string
      >;
      computedColor =
        paletteEntry.contrastLink || paletteEntry.contrastText || undefined;
    }
    return big ? (
      <MainLink
        target={target || undefined}
        onClick={onClick ? onClick.bind(this) : undefined}
        to={to}
        color={computedColor}
        activeStyle={{ opacity: 1, textDecoration: "underline" }}
        tabIndex={tabIndex === null ? undefined : tabIndex}
        className={className}
      >
        {children}
      </MainLink>
    ) : (
      <Link
        target={target || undefined}
        color={computedColor}
        onClick={onClick ? onClick.bind(this) : undefined}
        to={to}
        tabIndex={tabIndex === null ? undefined : tabIndex}
        className={className}
      >
        {children}
      </Link>
    );
  }
);

export default A;
